import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = ["hidden"]
const _hoisted_3 = { class: "px-6 py-5" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Comissões", -1)
const _hoisted_6 = { class: "flex h-full w-full flex-col items-center justify-start" }
const _hoisted_7 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_8 = { class: "col-span-6 -lg:flex -lg:flex-col" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left" }, "Comissões", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-left mt-1 pb-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Pagamento:"),
    /*#__PURE__*/_createTextVNode(" Os pagamentos serão realizados na quarta-feira da semana seguinte, caso a solicitação tenha sido gerada até a sexta-feira da semana atual.")
  ])
], -1)
const _hoisted_12 = { class: "flex h-full w-full flex-col items-center justify-start" }
const _hoisted_13 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_14 = { class: "col-span-8 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_15 = { class: "col-span-4 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_16 = { class: "flex flex-col my-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Filtrar histórico de repasse de Comissões", -1)
const _hoisted_18 = { class: "flex h-full w-full flex-col items-center justify-start" }
const _hoisted_19 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_20 = { class: "col-span-10 grid grid-cols-12 w-full gap-4 -lg:flex -lg:flex-col" }
const _hoisted_21 = { class: "col-span-2 flex h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_22 = {
  key: 0,
  class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
}
const _hoisted_23 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_24 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg p-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Histórico de solicitações", -1)
const _hoisted_26 = {
  key: 1,
  class: "shadow overflow-hidden flex flex-col items-center justify-center border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-max-screen"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("embed", {
  width: "75",
  height: "75",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "my-1 text-xs" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Carregando...")
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "w-8/12 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_31 = { class: "text-black" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-xl my-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Repasse de comissões Tecnopay")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "my-0 p-5" }, [
  /*#__PURE__*/_createElementVNode("p", null, "A funcionalidade de repasse de comissões conecta você diretamente ao nosso setor financeiro. Abaixo, fornecemos instruções para facilitar o processo de solicitação de repasse: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Cálculo de valores:"),
      /*#__PURE__*/_createTextVNode(" Os valores são calculados com base no período selecionado na busca. Se desejar alterar o período, faça a busca antes de solicitar o repasse. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Opções de Recebimento:"),
      /*#__PURE__*/_createTextVNode(" Atualmente, oferecemos três opções de recebimento: PIX, TED e Boleto Bancário. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Pagamento:"),
      /*#__PURE__*/_createTextVNode(" Os pagamentos serão realizados na quarta-feira da semana seguinte, caso a solicitação tenha sido gerada até a sexta-feira da semana atual. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Emissão de Nota Fiscal:"),
      /*#__PURE__*/_createTextVNode(" Para emitir a nota fiscal, utilize os serviços 10.04 ou 10.05. Se seu CNAE não permitir, entre em contato conosco para obter orientação. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Recebimento por PIX:"),
      /*#__PURE__*/_createTextVNode(" Se optar por receber por PIX, envie a nota fiscal e os dados da conta que corresponde ao CNPJ da nota fiscal. ")
    ]),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Recebimento por TED:"),
      /*#__PURE__*/_createTextVNode(" Para receber por TED, envie a nota fiscal e os dados da conta que correponde ao CNPJ da nota fiscal. ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Recebimento por Boleto Bancário:"),
      /*#__PURE__*/_createTextVNode(" Se preferir receber por boleto bancário, envie a nota fiscal e o boleto bancário utilizando os seguintes dados:"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("b", null, "CNPJ:"),
          /*#__PURE__*/_createTextVNode(" 40.776.910/0001-85")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("b", null, "Nome Empresarial:"),
          /*#__PURE__*/_createTextVNode(" TECNOSPEED PAGAMENTOS LTDA")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, " Esta funcionalidade simplifica o processo de solicitação de repasses de comissões, porém, todas as interações são realizadas exclusivamente por e-mail. Nosso objetivo é agilizar o preenchimento dos dados para facilitar a comunicação e garantir uma resposta adequada. ")
], -1)
const _hoisted_34 = { class: "my-1 p-5" }
const _hoisted_35 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_36 = { class: "grid gap-5" }
const _hoisted_37 = { class: "grid md:flex gap-5" }
const _hoisted_38 = { class: "grid md:flex gap-5" }
const _hoisted_39 = { class: "md:flex gap-5" }
const _hoisted_40 = { class: "grid" }
const _hoisted_41 = { class: "file-upload-wrapper custom-button rounded-lg w-48 h-12 justify-center items-center justify-self-center ml-2" }
const _hoisted_42 = {
  for: "inputFile",
  class: "file-upload-label justify-center items-center"
}
const _hoisted_43 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_44 = { class: "mb-px font-semibold leading-none mx-2" }
const _hoisted_45 = { class: "my-1 p-2 text-sm text-red-500 mt-1" }
const _hoisted_46 = {
  class: "text-sm",
  style: {"display":"ruby"}
}
const _hoisted_47 = { class: "file-uploaded-label items-center justify-between" }
const _hoisted_48 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_49 = { class: "truncate mb-px leading-none" }
const _hoisted_50 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "text-xl my-5"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", null, "Você receberá um e-mail assim que o pagamento for realizado.", -1)
const _hoisted_55 = { class: "flex items-center mt-4 h-full w-full justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_CustomInputAutocomplete = _resolveComponent("CustomInputAutocomplete")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Table = _resolveComponent("Table")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_CustomTextArea = _resolveComponent("CustomTextArea")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        success: _ctx.toastSuccess,
        onHide: _ctx.hide
      }, null, 8, ["label", "success", "onHide"])
    ], 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isRoot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_CustomInputAutocomplete, {
                        label: "Software house *",
                        class: "z-20 col-span-12",
                        searchValue: !_ctx.loadingSoftwareHouses ? _ctx.searchSoftwareHouseText : 'Carregando...',
                        searchFunction: () => (_ctx.softwareHouses = _ctx.searchSoftwareHouses()),
                        delay: 0,
                        minimumCharactersToShowList: 0,
                        disabled: _ctx.loadingSoftwareHouses,
                        listValues: 
                      _ctx.softwareHouses.map(({ nomeFantasia, razaoSocial, cnpj }) => {
                        return {
                          primaryText: nomeFantasia ? nomeFantasia : razaoSocial,
                          secondaryText: `${
                            cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                          } | ${razaoSocial}`,
                          id: cnpj,
                        };
                      })
                    ,
                        inputEvent: "update:input",
                        resultEvent: "update:select",
                        isIncorrect: _ctx.isSoftwareHouseIncorrect,
                        incorrectMessage: "Campo obrigatório!",
                        "onUpdate:input": _ctx.updateSearchSoftwareHouseText,
                        "onUpdate:select": _ctx.selectSoftwareHouse
                      }, null, 8, ["searchValue", "searchFunction", "disabled", "listValues", "isIncorrect", "onUpdate:input", "onUpdate:select"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isRoot || _ctx.softwareHouseSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(), _createBlock(_component_Select, {
                        label: "Mês",
                        options: () => _ctx.months,
                        key: _ctx.selectedMonth.key,
                        selected: _ctx.selectedMonth.value,
                        display: "value",
                        class: "col-span-6",
                        event: "update:select",
                        "onUpdate:select": _ctx.handleMonth
                      }, null, 8, ["options", "selected", "onUpdate:select"])),
                      _createVNode(_component_Input, {
                        class: "col-span-6",
                        modelValue: _ctx.selectedMonthTotal,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedMonthTotal) = $event)),
                        label: "Total a receber",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_PrimaryButton, {
                        label: "Solicitar repasse de comissões",
                        type: "button",
                        icon: _ctx.buttonIcons.commission.icon,
                        iconCustomClass: "text-white",
                        width: "w-full",
                        class: "col-span-12",
                        onClick: _ctx.handleCommissionModal
                      }, null, 8, ["icon", "onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(), _createBlock(_component_Select, {
                          label: "Situação",
                          options: () => _ctx.protocolStatusOptions,
                          key: _ctx.selectedProtocolStatus.key,
                          selected: _ctx.selectedProtocolStatus.value,
                          display: "value",
                          class: "col-span-4",
                          event: "update:select",
                          "onUpdate:select": _ctx.handleProtocolStatus
                        }, null, 8, ["options", "selected", "onUpdate:select"])),
                        _createVNode(_component_Input, {
                          modelValue: _ctx.startFilter,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startFilter) = $event)),
                          type: "date",
                          label: "Solicitado de",
                          class: "col-span-4",
                          isIncorrect: !!_ctx.errorMessage,
                          incorrectMessage: _ctx.errorMessage
                        }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"]),
                        _createVNode(_component_Input, {
                          modelValue: _ctx.endFilter,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endFilter) = $event)),
                          type: "date",
                          label: "Solicitado até",
                          class: "col-span-4",
                          isIncorrect: !!_ctx.errorMessage,
                          incorrectMessage: _ctx.errorMessage
                        }, null, 8, ["modelValue", "isIncorrect", "incorrectMessage"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_PrimaryButton, {
                          label: "Filtrar",
                          type: "button",
                          icon: _ctx.buttonIcons.search.icon,
                          iconCustomClass: "text-white",
                          width: "w-full",
                          class: "col-span-12",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getCommissionRequests()))
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              (!_ctx.protocolLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        (_openBlock(), _createBlock(_component_Table, {
                          columns: ['Protocolo', 'Situação', 'Período', 'Valor', 'Data de Recebimento', 'Data Solicitação'],
                          values: () => _ctx.commissionRequests.map(({ startDate, endDate, protocol, value, status, createdAt, receiptDate }) => {
                    const startDateISO = _ctx.parseISODate(startDate);
                    const endDateISO = _ctx.parseISODate(endDate);

                    const startDateUTC = new Date(startDateISO.getTime() + (startDateISO.getTimezoneOffset() * 60000))
                    const endDateUTC = new Date(endDateISO.getTime() + (endDateISO.getTimezoneOffset() * 60000))
                    return {
                      protocol: protocol,
                      status: _ctx.protocolStatus[status],
                      interval: `${_ctx.formatDate(startDateUTC, 'dd/MM/yyyy')} - ${_ctx.formatDate(endDateUTC, 'dd/MM/yyyy')}`,
                      value: Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value),
                      receiptDate: receiptDate ? _ctx.formatDate(_ctx.parseISODate(receiptDate), 'dd/MM/yyyy') : '-',
                      createdAt: _ctx.formatDate(_ctx.parseISODate(createdAt), 'dd/MM/yyyy'),
                    }
                  }),
                          key: JSON.stringify(_ctx.commissionRequests),
                          tableId: "protocol",
                          optionsColumn: true,
                          itemsPerPage: 20,
                          buttons: ['edit'],
                          "onUpdate:editTableItem": _ctx.handleEdit
                        }, null, 8, ["values", "onUpdate:editTableItem"]))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.commissionModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.commissionModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            (!_ctx.commissionForm.sent)
              ? (_openBlock(), _createBlock(_component_Accordion, {
                  key: 0,
                  menus: [
                  {
                    title: 'Como funciona',
                  },
                  {
                    title: 'Quero solicitar',
                  },
                ],
                  openMenuIndex: 0
                }, {
                  "0": _withCtx(() => [
                    _hoisted_33
                  ]),
                  "1": _withCtx(() => [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_Form, { class: "divide-transparent text-left" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_CustomInput, {
                              label: "E-mail do remetente",
                              name: "from",
                              type: "email",
                              class: "col-span-12 md:col-span-6",
                              value: _ctx.commissionForm.from,
                              validation: _ctx.commissionForm.validations.from,
                              onChange: _ctx.changeField
                            }, null, 8, ["value", "validation", "onChange"]),
                            _createVNode(_component_CustomInput, {
                              label: "Destinatário",
                              name: "to",
                              type: "email",
                              value: _ctx.commissionForm.to,
                              class: "col-span-12 md:col-span-6",
                              disabled: ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_CustomInput, {
                              label: "Assunto",
                              name: "subject",
                              value: _ctx.commissionForm.subject,
                              disabled: ""
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_CustomTextArea, {
                              label: "Mensagem padrão",
                              isIncorrect: false,
                              modelValue: _ctx.commissionForm.message,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.commissionForm.message) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(_component_CustomTextArea, {
                              label: "Complemento (Opcional)",
                              isIncorrect: false,
                              modelValue: _ctx.commissionForm.complement,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.commissionForm.complement) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("input", {
                              id: "inputFile",
                              ref: "imageUploader",
                              placeholder: "Imagem de perfil",
                              title: "Imagem de perfil",
                              type: "file",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetFile && _ctx.resetFile(...args))),
                              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.fileChangeHandler && _ctx.fileChangeHandler(...args))),
                              name: "attachment",
                              class: "file-upload-input"
                            }, null, 544),
                            _createElementVNode("label", _hoisted_42, [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  icon: _ctx.buttonIcons.upload.icon
                                }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.commissionForm.files.length > 0 ? 'Adicionar mais arquivos' : 'Adicionar arquivo'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.commissionForm.errorMessage), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commissionForm.files, (file, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "file-uploaded-wrapper custom-button rounded-lg w-48 h-12 justify-center items-center justify-self-center ml-2 mb-2"
                            }, [
                              _createElementVNode("label", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_FontAwesomeIcon, {
                                      icon: _ctx.buttonIcons.file.icon
                                    }, null, 8, ["icon"])
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_49, _toDisplayString(file.name), 1),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.removeFileCommission(index))
                                  }, [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_FontAwesomeIcon, {
                                        icon: _ctx.buttonIcons.trash.icon
                                      }, null, 8, ["icon"])
                                    ])
                                  ], 8, _hoisted_51)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("p", null, "Protocolo: " + _toDisplayString(_ctx.commissionForm.prototocolNumber), 1),
                  _hoisted_53,
                  _hoisted_54
                ]))
          ]),
          _createElementVNode("div", _hoisted_55, [
            (_ctx.commissionForm.sent)
              ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                  key: 0,
                  icon: _ctx.buttonIcons.done.icon,
                  label: "Finalizar",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(() => _ctx.commissionModal = false, ["prevent"])),
                  iconCustomClass: "text-white",
                  class: "ml-2",
                  width: "w-48 -lg:w-full",
                  type: "button"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (!_ctx.commissionForm.sent)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: "Cancelar",
                  icon: _ctx.buttonIcons.cancel.icon,
                  width: "w-48 -lg:w-full",
                  type: "button",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(() => _ctx.commissionModal = false, ["prevent"]))
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            (!_ctx.commissionForm.sent)
              ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                  key: 2,
                  icon: _ctx.buttonIcons.sendEmail.icon,
                  label: "Enviar",
                  onClick: _ctx.sendCommissionRequest,
                  iconCustomClass: "text-white",
                  class: "ml-2",
                  width: "w-48 -lg:w-full",
                  type: "button",
                  disabled: !_ctx.commissionForm.from || !_ctx.commissionForm.message || !_ctx.commissionForm.files.length ? true : false
                }, null, 8, ["icon", "onClick", "disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ]))
}